import { EngineClass } from '../systems/ClassRegistry.js';
import { Resource } from '../utils/ResourceManager.js';
import { property } from '../utils/serialization/decorator.js';

export const NAVIGATION_SETTINGS_RESOURCE_PREFIX = 'navmsettings';
export const NAVIGATION_SETTINGS_RESOURCE_EXTENSION = `.${NAVIGATION_SETTINGS_RESOURCE_PREFIX}.json`;

export function isNavigationSettingsResourcePath(path: string): boolean {
  return path.toLowerCase().endsWith(NAVIGATION_SETTINGS_RESOURCE_EXTENSION);
}

/**
 * Persisted Recast navmesh generation parameters for a scene.
 */
@EngineClass('NavigationSettings', { isResource: true, resourcePrefix: NAVIGATION_SETTINGS_RESOURCE_PREFIX })
export class NavigationSettings extends Resource {
  public override getEditorClassIcon(): string | null {
    return 'Icon_NavigationSettings';
  }

  @property()
  public cellSize: number = 0.2;

  @property()
  public cellHeight: number = 0.2;

  @property()
  public walkableSlopeAngle: number = 35;

  @property()
  public walkableHeight: number = 2;

  @property()
  public walkableClimb: number = 0.5;

  @property()
  public walkableRadius: number = 0.5;

  @property({ category: 'Advanced' })
  public maxEdgeLength: number = 12;

  @property({ category: 'Advanced' })
  public maxSimplificationError: number = 1.3;

  @property({ category: 'Advanced' })
  public minRegionArea: number = 8;

  @property({ category: 'Advanced' })
  public mergeRegionArea: number = 20;

  @property({ category: 'Advanced' })
  public maxVertsPerPoly: number = 6;

  @property({ category: 'Advanced' })
  public detailSampleDist: number = 6;

  @property({ category: 'Advanced' })
  public detailSampleMaxError: number = 1;

  @property({ category: 'Advanced' })
  public borderSize: number = 0;
}
